import React, { useEffect, useState } from "react";
import { color, motion } from "framer-motion";
import Slider from "react-slick";
import axios from "axios";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';

const BlogModal = ({ blog, onClose }) => {
  if (!blog) return null;

  return (
    <div className="modal-overlay11" onClick={onClose}>
      <div className="modal-content11" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header-section">
          <img
            className="modal-image11"
            src={`https://ethiccraft.org/${blog.image}`}
            alt={blog.name}
          />
          <div className="modal-text-info">
            <h3>{blog.name}</h3>
            <p><strong>Author:</strong> {blog.author}</p>
            <p><strong>Date:</strong> {blog.date}</p>
          </div>
        </div>
        <p className="modal-desc11">{blog.description}</p>
        <button onClick={onClose} className="btn btn-secondary blog-close-btn mt-3">Close</button>
      </div>
    </div>
  );
};

const BlogCard = ({ blog, onReadMore }) => {
  const { name, description, image, author, date } = blog;

  return (
    <motion.div
      className="blog-card"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      <div className="blog-image-container">
        <img src={`https://ethiccraft.org/${image}`} className="blog-image" />
      </div>
      <div className="blog-content">
        <h2 className="blog-title">{name}</h2>
        <p className="blog-description">
          {description.length > 50 ? `${description.slice(0, 210)}...` : description}
        </p>
        <div className="blog-footer">
          <p className="blog-author">By {author} • {date}</p>
          <motion.button className="like-btn" onClick={() => onReadMore(blog)}>
            Read More
          </motion.button>
        </div>
      </div>
    </motion.div>
  );
};



const CustomPrevArrow = (props) => {
  const { className, onClick } = props;
  return <FaArrowLeft className={className} onClick={onClick} style={{ color: 'black' }} />;
};

const CustomNextArrow = (props) => {
  const { className, onClick } = props;
  return <FaArrowRight className={className} onClick={onClick} style={{ color: 'black' }} />;
};

// --- Main Blog Slider ---
const BlogSlider = () => {
  const [blogs, setBlogs] = useState([]);
  const [selectedBlog, setSelectedBlog] = useState(null);

  useEffect(() => {
    // Replace with your real API
    axios.get("https://ethiccraft.org/backend/blog/read_isShown.php")
      .then(res => setBlogs(res.data))
      .catch(err => console.error("Error fetching blogs:", err));
  }, []);

  const settings = {
    // dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    arrow: true,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    autoplaySpeed: 4000,
    responsive: [
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <motion.div
      className="blog-slider-container"
      initial={{ opacity: 0, scale: 0.9 }}
      whileInView={{ opacity: 1, scale: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    >
      <h1 className="slider-title">Voice of Ethiccraft</h1>
      <Slider {...settings}>
        {blogs.map((blog, index) => (
          <BlogCard key={index} blog={blog} onReadMore={setSelectedBlog} />
        ))}
      </Slider>

      {selectedBlog && (
        <BlogModal blog={selectedBlog} onClose={() => setSelectedBlog(null)} />
      )}
    </motion.div>
  );
};

export default BlogSlider;